<template>
  <v-list style="white-space:nowrap;">
    <template v-if="$store.getters.companyContext === null">
      <v-list-item to="/admin/travel-service/all" v-if="$store.getters.hasPermission('travelOrderPreview')">
        <v-list-item-action>
          <v-icon>content_copy</v-icon>
        </v-list-item-action>
        <v-list-item-content>Zamówienia</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/travel-service/by-type/hotel" v-if="$store.getters.hasPermission('travelOrderResponseHotel')">
        <v-list-item-action>
          <v-icon>hotel</v-icon>
        </v-list-item-action>
        <v-list-item-content>Zamówienia hotelowe</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/travel-service/by-type/flight" v-if="$store.getters.hasPermission('travelOrderResponseFlight')">
        <v-list-item-action>
          <v-icon>flight</v-icon>
        </v-list-item-action>
        <v-list-item-content>Zamówienia lotnicze</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/travel-service/by-type/low-cost" v-if="$store.getters.hasPermission('travelOrderResponseFlightLowCost')">
        <v-list-item-action>
          <v-icon>near_me</v-icon>
        </v-list-item-action>
        <v-list-item-content>Zamówienia tanie linie lotnicze</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/travel-service/by-type/car" v-if="$store.getters.hasPermission('travelOrderResponseCar')">
        <v-list-item-action>
          <v-icon>drive_eta</v-icon>
        </v-list-item-action>
        <v-list-item-content>Zamówienia samochodów</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/travel-service/by-type/rail" v-if="$store.getters.hasPermission('travelOrderResponseRail')">
        <v-list-item-action>
          <v-icon>directions_railway</v-icon>
        </v-list-item-action>
        <v-list-item-content>Zamówienia kolejowe</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/travel-service/by-type/insurance" v-if="$store.getters.hasPermission('travelOrderResponseInsurance')">
        <v-list-item-action>
          <v-icon>local_pharmacy</v-icon>
        </v-list-item-action>
        <v-list-item-content>Zamówienia ubezpieczenia</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/travel-service/by-type/other" v-if="$store.getters.hasPermission('travelOrderResponseOther')">
        <v-list-item-action>
          <v-icon>fa-directions</v-icon>
        </v-list-item-action>
        <v-list-item-content>Zamówienia specjalne</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/companies" v-if="$store.getters.hasPermission('manageCompanies')">
        <v-list-item-action>
          <v-icon>business</v-icon>
        </v-list-item-action>
        <v-list-item-content>Lista firm</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/users" v-if="$store.getters.hasPermission('mainDbUserManage')">
        <v-list-item-action>
          <v-icon>people</v-icon>
        </v-list-item-action>
        <v-list-item-content>Lista użytkowników</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/mailing" v-if="$store.getters.hasPermission('manageMailingList')">
        <v-list-item-action>
          <v-icon>email</v-icon>
        </v-list-item-action>
        <v-list-item-content>Listy mailingowe</v-list-item-content>
      </v-list-item>

      <v-list-item to="/admin/system-settings" v-if="$store.getters.hasPermission('mainDbSettings')">
        <v-list-item-action>
          <v-icon>fa-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>Ustawienia systemowe</v-list-item-content>
      </v-list-item>
    </template>
    <template v-else>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="error">fa-exclamation-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>Firma: {{ $store.getters.companyContext }}</v-list-item-content>
      </v-list-item>

      <main-menu-standalone />

      <v-list-item @click="loginBack">
        <v-list-item-action>
          <v-icon>transfer_within_a_station</v-icon>
        </v-list-item-action>
        <v-list-item-content>Wróć na konto administracyjne</v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import MainMenuStandalone from "./MenuStandalone";
export default {
  name: "MainMenuAdmin",
  components: { MainMenuStandalone },
  data() {
    return {
      right: null,
      mini: true,
      drawer: true,
      hover: null,
      name: null,
      nameRules: null
    };
  },
  methods: {
    showFullMenu: function() {
      this.mini = false;
    },
    hideFullMenu: function() {
      this.mini = true;
    },
    is_user_logged: function() {
      return this.$store.getters.isAuthenticated;
    },
    loginBack() {
      this.axios.post("admin/company-admin/log-in-back-admin-context").then(resp => {
        this.$store.commit("TOKEN_CHANGE", resp.data.access_token);
        this.$store.commit("USER_DATA_CHANGE", {
          user_properties: resp.data.user_properties,
          skipSave: false
        });
        this.$store.commit("Shared/allTabsRedirect", "/admin/companies");
      });
    }
  }
};
</script>

<style scoped>
/*.navigation-drawer--temporary .list--tile--action {*/
/*  padding-left: 12px;*/
/*}*/

/*.v-list-tile--action {*/
/*  padding-left: 12px;*/
/*}*/

/*.v-navigation-drawer--mini-variant .v-list--tile--action {*/
/*  padding-left: unset;*/
/*}*/
</style>

<style scoped>
.v-list-item {
  justify-content: left !important;
}
</style>
